import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center bg-amber hover:bg-amber-hover text-charcoal font-bold py-4 px-8 rounded-full transition-colors duration-300 shadow-lg hover:shadow-xl text-lg sm:text-xl w-full sm:w-auto text-center';
  if (href) {
    return <motion.a href={href} onClick={e => {
      if (href.startsWith('#')) {
        e.preventDefault();
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${className} cursor-pointer`} data-id="element-299">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${className}`} {...props} data-id="element-300">
      {children}
    </motion.button>;
}